export default "__VITE_ASSET__C6XgY$dJ__"